import styled from 'styled-components';
import HelpIcon from '@material-ui/icons/Help';
import Header from '../../components/Header';
import { Flex } from '../Flex';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${(props) => props.$backgroundColor};
  height: 100%;
  width: 100vw;

  &::after {
    background-color: ${({ theme }) => theme.colors.blacks[1]};
    content: '';
    height: 100%;
    pointer-events: none;
    position: fixed;
    right: 0;
    top: 0;
    width: calc(100vw - 800px - 200px);
    z-index: 69;
  }
`;

const HelpContainer = styled(Flex).attrs(() => ({
  mt: 4,
  alignItems: 'center',
}))`
  svg {
    font-size: 26px;
    margin-right: 10px;
    color: ${({ theme }) => theme.colors.whites[7]};
  }

  .helper-text {
    color: white;
    font-weight: bold;
    margin: 0 5px;
  }
`;

const StyledText = styled.div`
  color: white;
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  letter-spacing: 0.5px;
  margin-right: 5px;
`;

const HelpText = styled.div`
  color: ${({ theme }) => theme.colors.neutrals[2]};
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-weight: 400;
  letter-spacing: 0.5px;
  cursor: pointer;
`;

const Content = styled.div`
  padding: 180px 28px 28px 75px;
  height: 100vh;
`;

const EmptyPage = ({
  headerActions,
  pageTitle,
  children,
  backgroundColor,
  showHelpSection = true,
  helpText,
}) => {
  return (
    <LayoutContainer $backgroundColor={backgroundColor}>
      <Header
        title={pageTitle}
        actions={headerActions || []}
        hideBackground
        isEmptyPage
      />
      <Content>
        {children}
        {showHelpSection && (
          <HelpContainer>
            <HelpIcon />
            <StyledText>{helpText || 'Need help?'}</StyledText>
          </HelpContainer>
        )}
      </Content>
    </LayoutContainer>
  );
};

export default EmptyPage;
